/* state/kommun-wiki.js — lazy-loader för Wikipedia-cachen.
 *
 * Fetchar /data/_generated/kommun_wiki.json en gång och cachar i minnet.
 * Bygger på samma data som kommun.js + compare.js använder för kommun-hero.
 * Pipeline: scripts/build_kommun_wikipedia_content.py (kör manuellt vid behov,
 * §13 quick reference).
 *
 * Public API:
 *   ensureKommunWiki()         — idempotent fetch, returnerar promise
 *   getKommunWikiImage(kod)    — sync lookup, returnerar URL-string eller null
 *   getKommunWikiExtract(kod)  — sync lookup, returnerar text eller null
 *   getKommunWikiPageUrl(kod)  — sync lookup, returnerar URL eller null
 *
 * När cache är tom (innan fetch hunnit klart) returnerar getters null.
 * Pattern: anropare kan både synkron-checka först (fast-path) och await:a
 * ensureKommunWiki() för säker async-apply.
 */

const WIKI_URL = '/data/_generated/kommun_wiki.json';

let cache = null;            // { kod: entry } | null (innan fetch klar)
let inflight = null;         // pågående promise, delas mellan parallella callers

function ensureKommunWiki() {
    if (cache) return Promise.resolve(cache);
    if (inflight) return inflight;
    inflight = fetch(WIKI_URL)
        .then((r) => (r && r.ok ? r.json() : null))
        .then((data) => { cache = data || {}; return cache; })
        .catch(() => { cache = {}; return cache; });
    return inflight;
}

function _entry(kod) {
    if (!cache || !kod) return null;
    return cache[kod] || null;
}

function getKommunWikiImage(kod) {
    const e = _entry(kod);
    if (!e || !e.image) return null;
    return '/data/_generated/' + e.image;
}

function getKommunWikiExtract(kod) {
    const e = _entry(kod);
    return e && e.extract ? e.extract : null;
}

function getKommunWikiPageUrl(kod) {
    const e = _entry(kod);
    return e && e.page_url ? e.page_url : null;
}

function getKommunWebsite(kod) {
    const e = _entry(kod);
    return e && e.website ? e.website : null;
}

function getKommunMovingUrl(kod) {
    const e = _entry(kod);
    return e && e.moving_url ? e.moving_url : null;
}

export { ensureKommunWiki, getKommunWikiImage, getKommunWikiExtract, getKommunWikiPageUrl, getKommunWebsite, getKommunMovingUrl };
